import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/logger'; // Initialize logger and console override
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from './components/common/Toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      {/*
        Global toast host (Bug #26 fix). react-toastify only renders toasts into
        a mounted <ToastContainer/>; without one, every `toast(...)` call across
        the app fired into the void. Mounted here (context-free, position:fixed —
        placement in the tree is irrelevant) rather than in App.tsx/MainLayout.tsx
        to keep this fix out of those hot files.
      */}
      <ToastContainer />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
